'use client'
import { useCloseModal } from '@l2p/apps-shared'
import React, { useCallback, useLayoutEffect } from 'react'
import CloseIcon from '../Buttons/CloseIcon/CloseIcon'
import { ModalProps } from './index'
import styles from './styles.module.scss'

const ModalComponent: React.FC<ModalProps> = ({
  children,
  width,
  height = 'auto',
  onClose,
  padding = 'auto',
  id = 'modal',
  className,
  closeIconClassName,
  showClose,
  bgColor,
  saveSize = false,
  overflowY = 'auto',
  closeOnlyOnCross = false,
  style = {},
}) => {
  const closeWindow = useCloseModal()

  // Lock scroll for body
  useLayoutEffect(() => {
    const originalStyle = window.getComputedStyle(document.body).overflow
    const scrollY = window.scrollY

    document.body.style.overflow = 'hidden'
    document.body.style.position = 'fixed'
    document.body.style.top = `-${scrollY}px`
    document.body.style.width = '100%'

    return () => {
      document.body.style.overflow = originalStyle
      document.body.style.position = ''
      document.body.style.top = ''
      document.body.style.width = ''
      window.scrollTo(0, scrollY)
    }
  }, [])

  const onModalClose = useCallback(() => {
    onClose ? onClose() : closeWindow()
  }, [closeWindow, onClose])

  return (
    <>
      <div
        id={id}
        className={`${styles.modalContainer} ${
          !saveSize ? styles.withoutSaveSize : styles.withSaveSize
        } ${className ? className : ''}`}
        style={{
          height: String(height),
          width: String(width),
          maxWidth: String(width),
          padding: String(padding),
          backgroundColor: bgColor,
          //@ts-ignore
          overflowY: overflowY,
          ...style,
        }}
      >
        {showClose && (
          <div className={`${styles.closeButton} ${closeIconClassName}`}>
            <CloseIcon onClickHandler={onModalClose} />
          </div>
        )}

        {children}
      </div>

      <div
        className={styles.modalOverlay}
        onClick={() => !closeOnlyOnCross && onModalClose()}
      />
    </>
  )
}

export default ModalComponent
